import { util } from '@/api/util';
import { contactCommonTypeFilter } from '@/api/logical/contact_constants';
export class ContactDBBase {
    constructor(ctx) {
        this.ctx = ctx;
        this.tablePrimaryKeyMap = {
            contact: 'id',
            contactItem: 'id',
            orgContact: 'id',
            org: 'id',
        };
    }
    async intoTable(options, config = { asSoon: false }) {
        const { tableName, list, _account } = options;
        const { asSoon = false, supportCache = 'enable', onProgress } = config;
        if ((!Array.isArray(list) || !list.length || !this.ctx.getEnablePutContact()) && !asSoon) {
            return [];
        }
        console.time(`[contact_dbl]intoTable${tableName}.${list.length}`);
        const res = await this.ctx.dbApi.putAll({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName,
            _dbAccount: _account,
            asSoon,
        }, list, {
            supportCache,
            onProgress,
        });
        console.timeEnd(`[contact_dbl]intoTable${tableName}.${list.length}`);
        return res;
    }
    getTableList(name, idList, contactType) {
        const filterName = contactType && name === this.ctx.contactUtil.contactTable ? contactCommonTypeFilter : undefined;
        const adCondition = {
            type: 'anyOf',
            args: [idList],
            field: 'id',
        };
        const query = {
            adCondition,
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: name,
            additionalData: {
                contactType,
            },
        };
        if (filterName) {
            query.filter = filterName;
            query.useDexieFilter = false;
        }
        return this.ctx.dbApi.getByRangeCondition(query);
    }
    async getDiffRes(params) {
        const { list, tableName, type } = params;
        const key = this.tablePrimaryKeyMap[tableName];
        const newList = util.getKeyListByList(list, key);
        const tableList = await this.getTableList(tableName, newList, type);
        const oldList = tableList && tableList.length ? util.getKeyListByList(tableList, key) : [];
        return util.getDiff(oldList, newList);
    }
    async getTableCount(options) {
        const { tableName, dbName = this.ctx.contactUtil.contactDbName, enterpriseId = 0 } = options;
        if (tableName === 'orgpathlist' && enterpriseId) {
            const list = await this.ctx.dbApi.getByRangeCondition({
                dbName,
                tableName,
                adCondition: {
                    type: 'equals',
                    field: 'enterpriseId',
                    args: [enterpriseId],
                },
                count: 1,
                _dbAccount: options._account,
            });
            return list.length;
        }
        return this.ctx.dbApi.getTableCount({
            dbName,
            tableName,
            _dbAccount: options._account,
        });
    }
    deleteData(options) {
        var _a;
        const { list, tableName, _account = (_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id } = options;
        if (list && list.length > 0) {
            return this.ctx.dbApi
                .deleteById({
                dbName: this.ctx.contactUtil.contactDbName,
                tableName,
                _dbAccount: _account,
            }, list)
                .then(() => {
                this.clearCache();
                return true;
            });
        }
        return Promise.resolve(true);
    }
    async clearTable(dbName) {
        return this.ctx.dbApi.clear({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: dbName,
        });
    }
    async restoreData(dbName, list) {
        await this.clearTable(dbName);
        this.ctx.dbApi.putAll({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: dbName,
        }, list);
    }
    async setContactList(data) {
        if (!Array.isArray(data) || !data.length) {
            return;
        }
        await this.ctx.dbApi.putAll({
            tableName: this.ctx.contactUtil.contactTable,
            dbName: this.ctx.contactUtil.contactDbName,
        }, data);
    }
    async setOrgList(data) {
        if (!Array.isArray(data) || !data.length) {
            return;
        }
        await this.ctx.dbApi.putAll({
            tableName: this.ctx.contactUtil.orgTable,
            dbName: this.ctx.contactUtil.contactDbName,
        }, data);
    }
    async delListByKey(params) {
        const { tableName, type } = params;
        const diffResult = await this.getDiffRes(params);
        const k = tableName + (type ? '_' + type : '');
        const res = {
            [k]: diffResult,
        };
        if (diffResult.deleteDiff) {
            try {
                await this.deleteData({
                    tableName,
                    list: diffResult.deleteDiff,
                    _account: params._account,
                });
            }
            catch (message) {
                console.error('[contact] delListByKey error', message, params);
            }
        }
        return res;
    }
    clearCache() {
        console.log('[contact] clearCache');
    }
}
